import { h } from 'preact';

const ProductSkeleton = () => {
  return (
    <div class="productSkeleton">
      <div class="grid grid-cols-1 lg:grid-cols-desktopPDP">
        <div class="grid grid-cols-2 gap-px auto-rows-min">
          <div class="aspect-[11/14] bg-gray-100"></div>
          <div class="aspect-[11/14] bg-gray-200"></div>
          <div class="aspect-[11/14] bg-gray-300"></div>
          <div class="aspect-[11/14] bg-gray-400"></div>
        </div>
        <div class="product-info px-[20px] lg:px-[40px]">
          <div class="py-[35px]">
            <span class="inline-block bg-grey-200 rounded-sm text-xs leading-[16px] py-[4.5px] px-[8.5px] mb-[10px]">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <h1 class="text-[24px] leading-[29px] mb-[5px] font-normal">
              <div
                class="uppercase text-[14px] leading-[18px] mb-[14px] mr-[5px] h-[32px]
          rounded-full w-20 bg-grey-200"
              ></div>
            </h1>
            <div class="text-[14px] leading-[18px] mb-[30px]">
              <span role="price" class="py-[6px] inline-block">
                <div
                  class="uppercase text-[14px] leading-[18px] mb-[14px] mr-[5px] h-[16px]
        rounded-full w-20 bg-grey-200"
                ></div>
              </span>
            </div>
            <div
              class="uppercase text-[14px] leading-[18px] mb-[14px] mr-[5px] h-[16px]
        rounded-full w-20 bg-grey-200"
            ></div>
            <div class="flex items-center gap-2 flex-wrap mb-[30px]">
              <button data-swatch="Favorite Fade">
                <div class="w-[34px] h-[34px] rounded-full outline outline-[1.25px] outline-grey-300 bg-grey-200 outline-offset-2"></div>
              </button>
              <button data-swatch="Beach Blue">
                <div class="w-[34px] h-[34px] rounded-full outline outline-[1.25px] outline-grey-300 bg-grey-200 outline-offset-2"></div>
              </button>
              <button data-swatch="Black">
                <div class="w-[34px] h-[34px] rounded-full outline outline-[1.25px] outline-grey-300 bg-grey-200 outline-offset-2"></div>
              </button>
              <button data-swatch="Dark Rinse">
                <div class="w-[34px] h-[34px] rounded-full outline outline-[1.25px] outline-grey-300 bg-grey-200 outline-offset-2"></div>
              </button>
              <button data-swatch="Light Vintage">
                <div class="w-[34px] h-[34px] rounded-full outline outline-[1.25px] outline-grey-300 bg-grey-200 outline-offset-2"></div>
              </button>
              <button data-swatch="White">
                <div class="w-[34px] h-[34px] rounded-full outline outline-[1.25px] outline-grey-300 bg-grey-200 outline-offset-2"></div>
              </button>
            </div>
            <div class="uppercase text-[14px] leading-[18px] mb-[12px] flex justify-between">
              <div>
                <div
                  class="uppercase text-[14px] leading-[18px] mb-[14px] mr-[5px] h-[16px]
          rounded-full w-20 bg-grey-200"
                ></div>
              </div>
              <a class="underline">
                <div
                  class="uppercase text-[14px] leading-[18px] mb-[14px] mr-[5px] h-[16px]
          rounded-full w-20 bg-grey-200"
                ></div>
              </a>
            </div>
            <div class="grid grid-cols-6 md:grid-cols-7 gap-y-[10px] gap-x-[13px] mb-[30px]">
              <button class="border-grey-200-1 bg-grey-200 text-white false flex items-center justify-center h-[44px] rounded-md text-sm border"></button>
              <button class="border-grey-200-1 bg-grey-200 text-white false flex items-center justify-center h-[44px] rounded-md text-sm border"></button>
              <button class="border-grey-200-1 bg-grey-200 text-white false flex items-center justify-center h-[44px] rounded-md text-sm border"></button>
              <button class="border-grey-200-1 bg-grey-200 text-white false flex items-center justify-center h-[44px] rounded-md text-sm border"></button>
              <button class="border-grey-200-1 bg-grey-200 text-white false flex items-center justify-center h-[44px] rounded-md text-sm border"></button>
              <button class="border-grey-200-1 bg-grey-200 text-white false flex items-center justify-center h-[44px] rounded-md text-sm border"></button>
              <button class="border-grey-200-1 bg-grey-200 text-white false flex items-center justify-center h-[44px] rounded-md text-sm border"></button>
            </div>
            <div class="flex items-center">
              <div class="flex items-center h-[50px] w-[95px] pl-[11px] border-1 border-grey-200 rounded-tl-[6px] rounded-bl-[6px]">
                <button class="h-full opacity-0 cursor-pointer">
                  <svg
                    width="12"
                    height="1"
                    viewBox="0 0 12 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="stroke-grey-200"
                  >
                    <line y1="0.5" x2="12" y2="0.5" stroke="black"></line>
                  </svg>
                </button>
                <input
                  class="quantity-input text-center w-[40px] border-0 m-0 text-white focus:!outline-none border-transparent focus:border-transparent focus:ring-0 opacity-0"
                  type="number"
                  name="quantity"
                  min="1"
                />
                <button class="h-full opacity-0 cursor-pointer">
                  <svg
                    class="stroke-grey-200"
                    width="12"
                    height="11"
                    viewBox="0 0 12 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0.949707"
                      y1="5.5"
                      x2="11.9415"
                      y2="5.5"
                      stroke="currentColor"
                    ></line>
                    <line
                      x1="6.44531"
                      y1="11"
                      x2="6.44531"
                      y2="2.1872e-08"
                      stroke="currentColor"
                    ></line>
                  </svg>
                </button>
              </div>
              <button class="bg-grey-200 grow self-stretch text-white border-1 border-grey-200 rounded-tr-[6px] rounded-br-[6px] cursor-pointer"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
